<template>
	<span class="activity-link-type-icon" aria-hidden="true">
		<span
			class="icon"
			:class="{
				project: linkType === LinkType.PROJECT,
				'saved-search': linkType === LinkType.SAVED_SEARCH,
			}"
		></span>
	</span>
</template>

<script setup lang="ts">
import { LinkType } from "@/types/activity"

defineProps<{
	linkType: LinkType
}>()
</script>

<style scoped>
.activity-link-type-icon {
	display: inline-flex;
	align-items: center;
	justify-content: center;
	width: var(--size-button-lg);
	height: var(--size-button-lg);
	border: var(--border-width-thin) solid var(--neutral-200);
	border-radius: var(--border-radius-md);
	color: var(--neutral-600);
	flex: 0 0 auto;

	.icon {
		width: var(--size-icon-lg);
		height: var(--size-icon-lg);
		background: currentColor;
		mask-position: center;
		mask-repeat: no-repeat;
		mask-size: contain;

		&.project {
			mask-image: url("/icons/activity-project.svg");
		}

		&.saved-search {
			mask-image: url("/icons/activity-saved-search.svg");
		}
	}
}
</style>
